import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3939_31632)">
      <path
        opacity="0.8"
        d="M2.11765 12.7058L28.3024 27.6691C28.5049 27.785 28.6634 27.9644 28.7534 28.1797C28.8434 28.3949 28.8598 28.6339 28.8001 28.8594C28.7403 29.0849 28.6077 29.2844 28.423 29.4268C28.2382 29.5692 28.0115 29.6466 27.7782 29.647H6.10518C5.58894 29.6471 5.09044 29.4586 4.70339 29.117C4.31635 28.7754 4.06742 28.3042 4.00341 27.7919L2.11765 12.7058Z"
        fill="url(#paint0_linear_3939_31632)"
      />
      <path
        opacity="0.8"
        d="M33.8824 12.7058L31.9966 27.7919C31.9326 28.3042 31.6837 28.7754 31.2966 29.117C30.9096 29.4586 30.4111 29.6471 29.8948 29.647H8.22283C7.98935 29.6471 7.76238 29.57 7.57724 29.4278C7.3921 29.2855 7.25917 29.086 7.19914 28.8604C7.13911 28.6348 7.15534 28.3956 7.24531 28.1802C7.33527 27.9647 7.49393 27.785 7.69659 27.6691L33.8824 12.7058Z"
        fill="url(#paint1_linear_3939_31632)"
      />
      <g filter="url(#filter0_d_3939_31632)">
        <path
          d="M18 8.4707L29.6386 26.3754C29.8463 26.695 29.964 27.0648 29.9791 27.4457C29.9941 27.8267 29.9061 28.2046 29.7243 28.5396C29.5424 28.8747 29.2735 29.1544 28.9459 29.3494C28.6183 29.5443 28.2442 29.6472 27.8629 29.6472H8.13705C7.75584 29.6472 7.38168 29.5443 7.05407 29.3494C6.72646 29.1544 6.45755 28.8747 6.27571 28.5396C6.09387 28.2046 6.00585 27.8267 6.02093 27.4457C6.03601 27.0648 6.15364 26.695 6.36141 26.3754L18 8.4707Z"
          fill="url(#paint2_linear_3939_31632)"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter="url(#filter1_d_3939_31632)">
        <path
          d="M15.8824 7.41184C15.8824 7.97347 16.1055 8.5121 16.5026 8.90924C16.8997 9.30638 17.4384 9.52948 18 9.52948C18.5616 9.52948 19.1003 9.30638 19.4974 8.90924C19.8945 8.5121 20.1176 7.97347 20.1176 7.41184C20.1176 7.13374 20.0629 6.85837 19.9565 6.60145C19.85 6.34452 19.694 6.11108 19.4974 5.91443C19.3008 5.71779 19.0673 5.56181 18.8104 5.45539C18.5535 5.34896 18.2781 5.29419 18 5.29419C17.7219 5.29419 17.4465 5.34896 17.1896 5.45539C16.9327 5.56181 16.6992 5.71779 16.5026 5.91443C16.306 6.11108 16.15 6.34452 16.0436 6.60145C15.9371 6.85837 15.8824 7.13374 15.8824 7.41184Z"
          fill="url(#paint3_linear_3939_31632)"
          shapeRendering="crispEdges"
        />
      </g>
      <path
        opacity="0.8"
        d="M31.7647 11.6469C31.7647 11.925 31.8195 12.2004 31.9259 12.4573C32.0323 12.7143 32.1883 12.9477 32.385 13.1443C32.5816 13.341 32.815 13.497 33.072 13.6034C33.3289 13.7098 33.6043 13.7646 33.8824 13.7646C34.1604 13.7646 34.4358 13.7098 34.6927 13.6034C34.9497 13.497 35.1831 13.341 35.3798 13.1443C35.5764 12.9477 35.7324 12.7143 35.8388 12.4573C35.9452 12.2004 36 11.925 36 11.6469C36 11.0853 35.7769 10.5467 35.3798 10.1495C34.9826 9.7524 34.444 9.5293 33.8824 9.5293C33.3207 9.5293 32.7821 9.7524 32.385 10.1495C31.9878 10.5467 31.7647 11.0853 31.7647 11.6469Z"
        fill="url(#paint4_linear_3939_31632)"
      />
      <path
        opacity="0.8"
        d="M0 11.6469C0 12.2086 0.223109 12.7472 0.620244 13.1443C1.01738 13.5415 1.55601 13.7646 2.11765 13.7646C2.67928 13.7646 3.21791 13.5415 3.61505 13.1443C4.01219 12.7472 4.23529 12.2086 4.23529 11.6469C4.23529 11.0853 4.01219 10.5467 3.61505 10.1495C3.21791 9.7524 2.67928 9.5293 2.11765 9.5293C1.55601 9.5293 1.01738 9.7524 0.620244 10.1495C0.223109 10.5467 0 11.0853 0 11.6469Z"
        fill="url(#paint5_linear_3939_31632)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3939_31632"
        x="1.01927"
        y="3.4707"
        width="33.9614"
        height="31.1765"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.197999 0 0 0 0 0.478402 0 0 0 0 0.816667 0 0 0 0.57 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3939_31632"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3939_31632"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_3939_31632"
        x="10.8824"
        y="4.29419"
        width="14.2353"
        height="14.2354"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.197999 0 0 0 0 0.478402 0 0 0 0 0.816667 0 0 0 0.57 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3939_31632"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3939_31632"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3939_31632"
        x1="15.4765"
        y1="12.7058"
        x2="17.3543"
        y2="30.0127"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E2F0F4" />
        <stop offset="1" stopColor="white" stopOpacity="0.56" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3939_31632"
        x1="20.523"
        y1="12.7058"
        x2="22.4006"
        y2="30.0127"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E2F0F4" />
        <stop offset="1" stopColor="white" stopOpacity="0.56" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3939_31632"
        x1="18"
        y1="8.4707"
        x2="21.236"
        y2="29.8696"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EDF6FF" />
        <stop offset="1" stopColor="#ACD7FF" stopOpacity="0.78" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3939_31632"
        x1="18"
        y1="5.29419"
        x2="18.7278"
        y2="9.54731"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EDF6FF" />
        <stop offset="1" stopColor="#ACD7FF" stopOpacity="0.78" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3939_31632"
        x1="33.8824"
        y1="9.5293"
        x2="34.6101"
        y2="13.7824"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E2F0F4" />
        <stop offset="1" stopColor="white" stopOpacity="0.56" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3939_31632"
        x1="2.11765"
        y1="9.5293"
        x2="2.8454"
        y2="13.7824"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E2F0F4" />
        <stop offset="1" stopColor="white" stopOpacity="0.56" />
      </linearGradient>
      <clipPath id="clip0_3939_31632">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
